import { ComponentType, Suspense } from 'react';
import { taskRelativePaths } from 'routes/close/closeURLs';

import { featureFlags } from 'utils/config/featureFlags';

export const createRelativeTaskRoutes = <
  T extends string = 'info' | 'activity' | 'comments',
>(
  Component: ComponentType<{ defaultTab?: T }>
) => [
  {
    path: taskRelativePaths.taskBase({ taskId: ':id' }),
    element: (
      <Suspense>
        <Component />
      </Suspense>
    ),
  },
  {
    path: taskRelativePaths.taskInfo({ taskId: ':id' }),
    element: (
      <Suspense>
        <Component defaultTab={'info' as T} />
      </Suspense>
    ),
  },
  {
    path: taskRelativePaths.taskActivity({ taskId: ':id' }),
    element: (
      <Suspense>
        <Component defaultTab={'activity' as T} />
      </Suspense>
    ),
  },
  {
    path: taskRelativePaths.taskComments({ taskId: ':id' }),
    element: (
      <Suspense>
        <Component defaultTab={'comments' as T} />
      </Suspense>
    ),
  },
  ...(featureFlags.FF__CLOSE_DEMO_PAGES
    ? [
        {
          path: taskRelativePaths.taskWorkflow({ taskId: ':id' }),
          element: (
            <Suspense>
              <Component defaultTab={'workflow' as T} />
            </Suspense>
          ),
        },
      ]
    : []),
  {
    path: taskRelativePaths.taskSingleComment({
      taskId: ':id',
      commentId: ':commentId',
    }),
    element: (
      <Suspense>
        <Component defaultTab={'comments' as T} />
      </Suspense>
    ),
  },
  {
    path: taskRelativePaths.taskSingleComment({
      taskId: ':id',
      commentId: ':commentId',
      replyId: ':replyId',
    }),
    element: (
      <Suspense>
        <Component defaultTab={'comments' as T} />
      </Suspense>
    ),
  },
];
